export { default } from "./AppInfo";
